<template>
  <div>
    <div v-for="rating in ratings"
      v-bind:key="rating.value"
      v-on:click="set(rating.value)"
      v-on:mouseover="starOver(rating.value)"
      v-on:mouseout="starOut()"
      class="rating d-inline-block"
      :class="[{ 'is-selected' : ((selectedValue >= rating.value) && selectedValue != null)}, size]">
      <i class="fa fa-star" aria-hidden="true"></i>
    </div>
    <div class="d-block">
      <small>&nbsp;{{ opinion }}&nbsp;</small>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  size: {
    type: String,
    default: 'normal',
  },
  rating: Number,
  disabled: {
    type: Boolean,
    default: false,
  },
})

const selectedValue = ref(props.rating)
const ratings = [
  {
    value: 1,
    label: 'Very bad',
  },
  {
    value: 2,
    label: 'Bad',
  },
  {
    value: 3,
    label: 'Average',
  },
  {
    value: 4,
    label: 'Good',
  },
  {
    value: 5,
    label: 'Great!',
  },
]
const temp_value = ref(null)

const { t } = useI18n();
const opinion = computed(() => {
  const label = ratings.find((rating) => String(rating.value) === String(selectedValue.value))?.label;
  return label ? t(label) : '';
})
watch(
  () => props.rating,
  (newValue) => {
    selectedValue.value = newValue;
    temp_value.value = newValue;
  },
)
const starOver = (index) => {
  if (props.disabled) {
    return;
  }
  temp_value.value = selectedValue.value;
  selectedValue.value = index;
}
const starOut = () => {
  if (props.disabled) {
    return;
  }
  selectedValue.value = temp_value.value
}

const emit = defineEmits(['change']);
const set = (value) => {
  if (props.disabled) {
    return;
  }
  emit('change', value);
  temp_value.value = value;
  selectedValue.value = value;
}
</script>

<style scoped lang="scss">
.rating{
  cursor: pointer;
  padding: 0 0.1em;
  margin: 0 0 -0.5em 0;
  i{
    transition: color .2s ease-out;
    color: #f0f0f0;
  }
  &.is-selected{
    i{
      color: #f2b01e;
    }
  }
  &.normal{
    font-size: 2em;
  }
  &.small{
    font-size: 1em;
  }
  &.big{
    font-size: 3em;
  }
}
</style>
